import React from 'react';
import { Typography, FormControl, FormControlLabel, Checkbox, Skeleton, Box } from '@mui/material';
import get from 'lodash/get';

const InputCheckbox = ({ formik, name, label, disabled, fullWidth = true, loading, ...props }) => {
    return (
        <FormControl fullWidth={fullWidth}>
            <Typography className='pb-2 pl-2' component="label" htmlFor={name} color={disabled ? "text.lite" : "text.main"}>
                {label}
            </Typography>

            {loading ? (
                <Skeleton className="mb-2" variant="rounded" width={fullWidth ? "100%" : "30%"} height={39} />
            ) : (
                <FormControlLabel
                    control={
                        <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                            <Checkbox
                                id={name}
                                name={name}
                                checked={get(formik, `values.${name}`)}
                                onChange={formik.handleChange}
                                disabled={disabled}
                                {...props}
                            />
                        </Box>
                    }
                    label=""
                    sx={{ width: '100%', justifyContent: 'center' }}
                />
            )}
        </FormControl>
    );
};

export default InputCheckbox;
